export default "__VITE_ASSET__BLJp3vB0__"